import styled from '@emotion/styled';
import { Flex } from '@pairy/pds-react';

import { Z_INDEX } from '@/constants/zIndex';

export const FlexWrapper = styled(Flex)`
  overflow: hidden;
  background-image: url('/images/user/fire.png'),
    linear-gradient(122.77deg, #471c1c 0.78%, #27394f 69.58%);
  background-position: right bottom, left top;
  background-repeat: no-repeat, repeat;
  border-radius: 8px;
`;

export const Wrapper = styled(Flex)`
  position: relative;
  overflow: hidden;
  width: 349px;
  height: 380px;
  border-radius: 8px;
  box-shadow: ${({ theme }) => theme.elevation.md};
`;

export const UpdateWrapper = styled(Wrapper)`
  background-color: ${({ theme }) => theme.colors.white};
`;

export const UpdateImageWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
`;

export const VersionWrapper = styled(Wrapper)`
  background: #dcff90;
`;

export const VersionImageWrapper = styled.div`
  position: absolute;
  top: 20px;
  left: 0;
`;

export const CtaWrapper = styled(Wrapper)`
  background-color: ${({ theme }) => theme.colors.white};
`;

export const CtaImageWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
`;

export const TextWrapper = styled.div`
  z-index: ${Z_INDEX.onTop};
`;
